export default __webpack_public_path__ + "static/media/IMG_20190720_200734.36e30648.jpg";